import React from 'react';

import './FieldGroup.scss';

const FieldGroup = (props) => {
  return (
    <div className="parkchirp--fieldgroup">
      {props.label && <h2 className="parkchirp--fieldgroup-heading">{props.label}</h2>}
      {props.children && <div className="parkchirp--fieldgroup-content">{props.children}</div>}
    </div>
  );
};

export default FieldGroup;
